"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _Header = require("./Header.style");
var _AskICIS = _interopRequireDefault(require("../../../AskICIS"));
var _Functionality = _interopRequireDefault(require("../../Desktop/NavItem/Functionality"));
const Header = _ref => {
  var _askICISConfig$icon;
  let {
    showHamburgerMenu,
    showSearch,
    onMenuToggle,
    onSearchToggle,
    isSearchShowing,
    isMenuOpen,
    menuItems
  } = _ref;
  const askICISConfig = menuItems === null || menuItems === void 0 ? void 0 : menuItems.services.find(item => {
    var _item$icon;
    return (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.includes('AskICIS');
  });
  return /*#__PURE__*/_react.default.createElement(_Header.HeaderWrapper, {
    "data-testid": "sbheader-navigation"
  }, showHamburgerMenu && /*#__PURE__*/_react.default.createElement(_Header.HamburgerButton, {
    "data-test-id": "res-menu",
    isMenuOpen: isMenuOpen,
    onClick: onMenuToggle
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "menu",
    size: "lg",
    color: isMenuOpen ? _uiKit.theme.colours.PRIMARY_1 : _uiKit.theme.colours.WHITE
  })), /*#__PURE__*/_react.default.createElement(_Header.LogoWrapper, null, /*#__PURE__*/_react.default.createElement(_Header.IcisLogo, null)), askICISConfig && /*#__PURE__*/_react.default.createElement(_Functionality.default, {
    type: askICISConfig.type || "ExternalLink",
    link: askICISConfig.link
  }, /*#__PURE__*/_react.default.createElement(_AskICIS.default, {
    isBeta: (_askICISConfig$icon = askICISConfig.icon) === null || _askICISConfig$icon === void 0 ? void 0 : _askICISConfig$icon.toLowerCase().includes('beta')
  })), showSearch && /*#__PURE__*/_react.default.createElement(_Header.SearchButton, {
    onClick: onSearchToggle,
    isSearchShowing: isSearchShowing
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "search",
    size: "lg",
    color: isSearchShowing ? _uiKit.theme.colours.PRIMARY_1 : _uiKit.theme.colours.WHITE
  })));
};
var _default = exports.default = Header;